import { GrowpIcon } from 'packages/components/GrowpIcon'
import { PermEnum } from 'packages/sdks-next/growp'

import { MenuItemUnion } from 'packages/web-layout/types'

/**
 * 试卷管理的菜单定义
 *
 * @returns 菜单定义
 */
export const useTestPaperMenu: () => MenuItemUnion[] = () => {
  return [
    {
      path: '/admin/test-paper',
      label: (
        <GrowpIcon
          name="Paper"
          text="试卷管理"
          size={14}
          textMarginLeft={16}
        />
      ),
      labelText: '试卷管理',
      height: 40,
      perm: PermEnum.Paper,
    },
  ]
}
